// The one warning every logbook list shows for a photo failure, and the one
// place either sentence is spelled.
//
// It is rendered INSIDE the card, never through the page's StatusMessage --
// that one belongs to the entries read, and an unreadable S3 prefix must not
// look like a page that failed to load. The table renders exactly as it does
// with photos off. It is said at all, rather than staying silent, because
// photos are on by default: otherwise the page is indistinguishable from one
// whose entries have none.
//
// The two kinds get their own sentence. Telling someone who tapped one photo
// that none of them loaded is false on its face with the other thumbnails on
// screen beside it -- which is why useEntryPhotos tags the error rather than
// sharing one untagged channel.
//
// THE DISMISSAL LIVES HERE, keyed on the error OBJECT rather than a boolean:
// every failure is a fresh object, so a NEW one still speaks after an earlier
// one was waved away, and a failed photo-open is the gesture that most needs an
// answer. Holding that state here rather than in each page is the whole reason
// this component exists -- three pages kept identical copies of it, and a flag
// creeping back into one of them is exactly the regression nobody would see.
//
// `show` is the host's Show photos switch: a warning about photos nobody is
// looking at is noise, and toggling off and on is also the retry.

import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';

// `subject` names what the listing was for, so the task lists can say "tasks"
// where the logbook lists say "entries". It defaults to the wording every
// existing caller already gets, which is what leaves their suites unedited.
export function PhotoErrorAlert({ error, show, subject = 'entries' }) {
  const [dismissed, setDismissed] = useState(null);

  if (!error || !show || error === dismissed) return null;

  return (
    <Alert
      variant="warning"
      dismissible
      onClose={() => setDismissed(error)}
      className="py-2 small"
    >
      {error.kind === 'open'
        ? `Couldn't open ${error.name}.`
        : `Couldn't load the photos for these ${subject}.`}
    </Alert>
  );
}

export default PhotoErrorAlert;
